import { Image, LargeTitle, makeStyles, Subtitle2 } from '@fluentui/react-components';
import { FC } from 'react';
import './WelcomeBox.scss';
import { OpenAiLogo } from '../Common/OpenAiLogo';
import { useConversations, useGptConfigurations } from '../../store/hooks';
import { getGptIconAsset } from '../../Utils/image';
import GptMessageBar from '../Common/GptMessageBar';

const styles = makeStyles({
    description: {
        maxWidth: '800px',
        textAlign: 'center'
    }
});

export const WelcomeBox: FC = () => {
    const classes = styles();
    const { activeGpt } = useConversations();

    return (
        <div className='container'>
            {
                // SyGPT logo has different ratio size compared to other GPTs logo, so it is handled separately
                activeGpt?.isDefault
                    ? <OpenAiLogo></OpenAiLogo>
                    : <Image src={getGptIconAsset(activeGpt?.icon)} height={80} />
            }
            {
                !activeGpt?.isDefault && <LargeTitle align='center'>{activeGpt?.name}</LargeTitle>
            }
            {
                activeGpt?.isDefault
                    ? <LargeTitle align='center' className='welcome-title'>Hello Syensqo Explorer<br />How can I help you today?</LargeTitle>
                    : <Subtitle2 className={classes.description}>{activeGpt?.description}</Subtitle2>
            }
            {activeGpt?.disclaimer &&
                <GptMessageBar title='Note' text={activeGpt?.disclaimer} />
            }
        </div>
    );
};
